import React from "react"

const LogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="70"
    height="50"
    viewBox="0 0 70 50"
  >
    <g id="logo" data-name="Logo">
      <path
        id="logo__path"
        data-name="logo-path"
        d="M1132.383-209.129l3.339,6.785,3.308,6.806,6.614,13.614-.394-.279,16.085-.219-.527,1.2-6.515-11.711-6.491-11.731-6.481-11.739-6.45-11.764h1.457l-6.421,11.788-6.45,11.764L1117-192.853l-6.483,11.737-.238.431-.417,0-8.042-.057-8.042-.083-1.264-.013.7-1.263,6.528-11.7,6.555-11.679,6.592-11.649,3.3-5.822,3.323-5.8-3.111,5.975-3.135,5.955-6.276,11.905-6.313,11.876-6.34,11.854-.559-1.276,8.042-.083,8.042-.057-.655.428L1115.593-194l6.413-11.795,6.417-11.791,6.447-11.766.731-1.334.726,1.334,6.418,11.791,6.386,11.816,6.377,11.823,6.353,11.843.653,1.217-1.18-.016-16.085-.219-.27,0-.124-.275L1138.6-195.24l-3.126-6.934Z"
        transform="translate(-1092.515 230.685)"
        fill="#00adff"
      />
    </g>
  </svg>
)

export default LogoIcon
